import {ThemeProvider} from "@mui/material";
import theme from "./config/theme/theme";

import Header from "./components/Header";
import Landing from "./components/Landing";
import Footer from "./components/Footer";

const App = () => {
  const scrollToSection = (to) => document.getElementById(to)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <ThemeProvider theme={theme}>
      <Header scrollToSection={scrollToSection}/>
      <Landing scrollToSection={scrollToSection}/>
      <Footer />
    </ThemeProvider>
  );
};

export default App;
